<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Operadores</h3>
        </div>
        <!-- Page Header -->
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div style="background-color: #fff; padding: 1rem 2rem; border-radius: .625rem .625rem .625rem .625rem;">
              <h3 id="modalTitle"></h3>
              <nav v-if="!loadingModal" class="nav-steps" aria-label="breadcrumb">
                <ol style="background-color: #fff; padding: 0.75rem 0rem" class="breadcrumb">
                  <template v-for="(step, idxStep) in steps">
                    <li class="breadcrumb-item" :key="'step' + idxStep" v-if="step.isEnabled && !step.isHidden">
                      <a class="black-text" href="#" v-on:click="GoToStep(idxStep, $event)"
                        :class="[mCurrentStep == idxStep ? 'active' : '']">{{ step.title }}</a>
                      <i class="fas fa-angle-right mx-2" aria-hidden="true" v-if="!IsLastEnabledStep(idxStep)"></i>
                    </li>
                  </template>
                </ol>
              </nav>
              <div v-if="loadingModal">
                <loader :is-loading="loadingModal"></loader>
              </div>
              <div v-else>
                <div v-show="mCurrentStep === 0">
                  <ValidationObserver tag="form" ref="companyInfo">
                    <b-form-row>
                      <b-col md="8" class="form-group">
                        <label>Nome do operador</label>
                        <ValidationProvider rules="required:true|min:3" v-slot="{ errors, invalid }">
                          <b-form-input :class="
                            steps[mCurrentStep].isValidated
                              | showValidateError(invalid)
                          " type="text" v-model="infoOperator.NomeOperador" :disabled="isSeeing" />
                          <div class="invalid-feedback d-block" v-if="steps[mCurrentStep].isValidated">
                            {{ errors[0] }}
                          </div>
                        </ValidationProvider>
                      </b-col>
                    </b-form-row>
                    <br>
                    <h4>Dados da empresa</h4>
                    <div style="border-top: 1px solid #dee2e6;">
                      <br>
                      <b-form-row>
                        <b-col md="8" class="form-group">
                          <label>Nome</label>
                          <ValidationProvider rules="required:true|min:3" v-slot="{ errors, invalid }">
                            <b-form-input :class="
                              steps[mCurrentStep].isValidated
                                | showValidateError(invalid)
                            " type="text" v-model="infoOperator.Name" :disabled="isSeeing" />
                            <div class="invalid-feedback d-block" v-if="steps[mCurrentStep].isValidated">
                              {{ errors[0] }}
                            </div>
                          </ValidationProvider>
                        </b-col>

                        <b-col md="4" class="form-group">
                          <label>CNPJ</label>
                          <ValidationProvider rules="required|min:14" v-slot="{ errors, invalid }">
                            <the-mask :class="
                              steps[mCurrentStep].isValidated
                                | showValidateError(invalid)
                            " :disabled="isSeeing" :mask="['##.###.###/####-##']" class="form-control"
                              placeholder="CNPJ" type="tel" v-model="infoOperator.Identity" />
                            <div class="invalid-feedback d-block" v-if="steps[mCurrentStep].isValidated">
                              {{ errors[0] }}
                            </div>
                          </ValidationProvider>
                        </b-col>
                      </b-form-row>

                      <b-form-row>
                        <b-col md="12" class="form-group">
                          <label>Nome fantasia</label>
                          <ValidationProvider rules="required:true|min:3" v-slot="{ errors, invalid }">
                            <b-form-input :class="
                              steps[mCurrentStep].isValidated
                                | showValidateError(invalid)
                            " type="text" v-model="infoOperator.CommercialName" :disabled="isSeeing" />
                            <div class="invalid-feedback d-block" v-if="steps[mCurrentStep].isValidated">
                              {{ errors[0] }}
                            </div>
                          </ValidationProvider>
                        </b-col>
                      </b-form-row>
                    </div>

                    <br>
                    <h4>Endereço</h4>
                    <div style="border-top: 1px solid #dee2e6;">
                      <br>
                      <b-form-row>
                        <b-col md="4" class="form-group">
                          <label>CEP</label>
                          <ValidationProvider rules="required|min:8" v-slot="{ errors, invalid }">
                            <the-mask v-model="infoOperator.Address.ZipCode" :class="
                              steps[mCurrentStep].isValidated
                                | showValidateError(invalid)
                            " :disabled="isSeeing" @change.native="SearchByZipCode()" class="form-control" type="tel"
                              :mask="['#####-###']" />
                            <div class="invalid-feedback d-block" v-if="steps[mCurrentStep].isValidated">
                              {{ errors[0] }}
                            </div>
                          </ValidationProvider>
                        </b-col>
                        <b-col md="8" class="form-group">
                          <label>Rua</label>
                          <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                            <d-form-input :class="
                              steps[mCurrentStep].isValidated
                                | showValidateError(invalid)
                            " type="text" v-model="infoOperator.Address.Street" :disabled="isSeeing" />
                            <div class="invalid-feedback d-block" v-if="steps[mCurrentStep].isValidated">
                              {{ errors[0] }}
                            </div>
                          </ValidationProvider>
                        </b-col>
                      </b-form-row>
                      <b-form-row>
                        <b-col md="4" class="form-group">
                          <label>Número</label>
                          <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                            <the-mask class="form-control" :class="
                              steps[mCurrentStep].isValidated
                                | showValidateError(invalid)
                            " type="tel" :mask="['##########']" v-model="infoOperator.Address.Number"
                              :disabled="isSeeing" />
                            <div class="invalid-feedback d-block" v-if="steps[mCurrentStep].isValidated">
                              {{ errors[0] }}
                            </div>
                          </ValidationProvider>
                        </b-col>
                        <b-col md="8" class="form-group">
                          <label>Bairro</label>
                          <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                            <d-form-input type="text" :class="
                              steps[mCurrentStep].isValidated
                                | showValidateError(invalid)
                            " v-model="infoOperator.Address.District" :disabled="isSeeing" />
                            <div class="invalid-feedback d-block" v-if="steps[mCurrentStep].isValidated">
                              {{ errors[0] }}
                            </div>
                          </ValidationProvider>
                        </b-col>
                      </b-form-row>

                      <b-form-row>
                        <!-- Country -->
                        <b-col md="4" class="form-group">
                          <label for="parInputCountry">País</label>
                          <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                            <b-select :class="
                              steps[mCurrentStep].isValidated
                                | showValidateError(invalid)
                            " v-model="infoOperator.Address.Country.Name" :value="null" id="parInputCountry"
                              v-bind:disabled="isSeeing">
                              <option :value="null" selected>Selecione</option>
                              <option v-for="country in countries" v-bind:value="country.Name" v-bind:key="country.Id">
                                {{ country.Name }}
                              </option>
                            </b-select>
                            <div class="invalid-feedback d-block" v-if="steps[mCurrentStep].isValidated">
                              {{ errors[0] }}
                            </div>
                          </ValidationProvider>
                        </b-col>

                        <!-- State -->
                        <b-col md="4" class="form-group">
                          <label for="parInputState">Estado</label>
                          <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                            <b-select :class="
                              steps[mCurrentStep].isValidated
                                | showValidateError(invalid)
                            " v-model="infoOperator.Address.State.Initials" :value="null" id="parInputState"
                              v-bind:disabled="isSeeing">
                              <option :value="null" selected>Selecione</option>
                              <option v-for="state in states" v-bind:key="state.Initials" v-bind:value="state.Initials">
                                {{ state.Name }}
                              </option>
                            </b-select>
                            <div class="invalid-feedback d-block" v-if="steps[mCurrentStep].isValidated">
                              {{ errors[0] }}
                            </div>
                          </ValidationProvider>
                        </b-col>

                        <!-- City -->
                        <b-col md="4" class="form-group">
                          <label for="parInputCity">Cidade</label>
                          <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                            <b-select :class="
                              steps[mCurrentStep].isValidated
                                | showValidateError(invalid)
                            " v-model="infoOperator.Address.City.Name" :value="null" id="parInputCity"
                              v-bind:disabled="isSeeing">
                              <option :value="null" v-if="infoOperator.Address.State.Initials == null" selected>
                                Selecione
                              </option>
                              <option :value="null" v-else selected>Selecione</option>
                              <option v-for="city in cities" v-bind:key="city.Code" v-bind:value="city.Name">
                                {{ city.Name }}
                              </option>
                            </b-select>
                            <div class="invalid-feedback d-block" v-if="steps[mCurrentStep].isValidated">
                              {{ errors[0] }}
                            </div>
                          </ValidationProvider>
                        </b-col>
                      </b-form-row>
                    </div>

                    <br>
                    <h4>Dados do responsável</h4>
                    <div style="border-top: 1px solid #dee2e6;">
                      <br>
                      <b-form-row>
                        <b-col md="6" class="form-group">
                          <label>Nome</label>
                          <ValidationProvider rules="required:true|min:3" v-slot="{ errors, invalid }">
                            <b-form-input :class="steps[mCurrentStep].isValidated | showValidateError(invalid)"
                              type="text" v-model="infoOperator.ResponsibleName" :disabled="isSeeing" />
                            <div class="invalid-feedback d-block" v-if="steps[mCurrentStep].isValidated">
                              {{ errors[0] }}
                            </div>
                          </ValidationProvider>
                        </b-col>
                        <b-col md="6" class="form-group">
                          <label>CPF</label>
                          <ValidationProvider rules="required|min:11" v-slot="{ errors, invalid }">
                            <the-mask class="form-control"
                              :class="steps[mCurrentStep].isValidated | showValidateError(invalid)" type="text"
                              placeholder="CPF do responsável" :mask="['###.###.###-##']"
                              v-model="infoOperator.ResponsibleIdentity" :disabled="isSeeing" />
                            <div class="invalid-feedback d-block" v-if="steps[mCurrentStep].isValidated">
                              {{ errors[0] }}
                            </div>
                          </ValidationProvider>
                        </b-col>
                      </b-form-row>

                      <b-form-row>
                        <b-col md="6" class="form-group">
                          <label>E-mail</label>
                          <ValidationProvider rules="required|email" v-slot="{ errors, invalid }">
                            <b-form-input :class="
                              steps[mCurrentStep].isValidated
                                | showValidateError(invalid)
                            " type="email" v-model="infoOperator.Email" :disabled="isSeeing" />
                            <div class="invalid-feedback d-block" v-if="steps[mCurrentStep].isValidated">
                              {{ errors[0] }}
                            </div>
                          </ValidationProvider>
                        </b-col>

                        <b-col md="6" class="form-group">
                          <label>Telefone</label>
                          <ValidationProvider rules="required|min:10" v-slot="{ errors, invalid }">
                            <b-input-group seamless>
                              <b-input-group-text slot="prepend">
                                <i class="fas fa-phone-alt"></i>
                              </b-input-group-text>
                              <the-mask id="parPhone" class="form-control" type="tel"
                                :class="steps[mCurrentStep].isValidated | showValidateError(invalid)"
                                :mask="['(##) #####-####', '(##) ####-####']" v-model="infoOperator.ResponsiblePhone"
                                placeholder="Telefone do responsável" :disabled="isSeeing" />
                            </b-input-group>
                            <div class="invalid-feedback d-block" v-if="steps[mCurrentStep].isValidated">
                              {{ errors[0] }}
                            </div>
                          </ValidationProvider>
                        </b-col>
                      </b-form-row>
                    </div>
                  </ValidationObserver>
                </div>
                <div v-show="mCurrentStep === 1">
                  <table class="table mt-3 mb-4" :key="'OPMtable-' + keyOPMtable" v-if="
                    selected_payment == null &&
                    infoOperator.OperatorPaymentMethod.length > 0
                  ">
                    <thead class="bg-s2p-gray-light">
                      <tr>
                        <th>Método de pagamento</th>
                        <th class="text-center">Convênios configurados</th>
                        <th class="actions"></th>
                      </tr>
                    </thead>

                    <tbody>
                      <template v-for="(
                        paymentMethod, idxPymtMethod
                      ) in infoOperator.OperatorPaymentMethod">
                        <tr v-bind:key="'OPM-' + idxPymtMethod">
                          <td>
                            {{ GetPaymentNameByCode(paymentMethod.PaymentMethod.Code) }}
                          </td>
                          <td class="text-center">
                            {{ paymentMethod.OperatorPaymentMethodAgreements.length }}
                          </td>
                          <td>
                            <div class="text-right">
                              <b-button size="sm" variant="outline-secondary" @click="
                                selected_payment = paymentMethod.PaymentMethod.Code
                              ">
                                <i class="fas fa-eye mr-2"></i> Visualizar
                              </b-button>
                              <b-button v-if="!isSeeing" size="sm" variant="outline-secondary"
                                @click="RemovePayment(idxPymtMethod)">
                                <i class="fas fa-trash-alt" />
                              </b-button>
                            </div>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                  <div v-if="
                    selected_payment == null &&
                    infoOperator.OperatorPaymentMethod.length == 0
                  " class="m-5 text-center">
                    <span>Nenhum método de pagamento cadastrado.</span>
                  </div>

                  <div v-if="!isSeeing && selected_payment == null">
                    <b-form-row>
                      <b-col md="12">
                        <div class="form-group">
                          <label>Adicionar um método de pagamento não listado</label>
                          <b-select v-model="selected_payment">
                            <option :value="null">Selecione</option>
                            <option v-for="method in paymentMethods" v-bind:value="method.Code" v-bind:key="method.Code"
                              v-if="!IsPaymentAlreadyAdded(method.Code)">
                              {{ method.Name }}
                            </option>
                          </b-select>
                        </div>
                      </b-col>
                    </b-form-row>
                  </div>

                  <div v-if="selected_payment != null">
                    <b-row class="mb-2">
                      <b-col md="6">
                        <b-button class="btn btn-outline-secondary btn-sm" @click="selected_payment = null"
                          title="Voltar para lista de métodos de pagamentos">
                          <i class="fas fa-arrow-left"></i>
                        </b-button>
                      </b-col>
                    </b-row>

                    <h4 class="text-center mb-3">
                      {{ GetPaymentNameByCode(selected_payment) }}
                    </h4>

                    <table class="table mb-0" :key="agreementsTableKey">
                      <thead class="bg-s2p-gray-light">
                        <tr>
                          <th>Convênio</th>
                          <th class="text-center">Gateway</th>
                          <th class="text-center">Ordem</th>
                          <th class="actions"></th>
                        </tr>
                      </thead>

                      <tbody>
                        <template v-for="(
                          agreement, idxAgreement
                        ) in activeOPM.OperatorPaymentMethodAgreements">
                          <tr v-bind:key="'OPMA-' + idxAgreement">
                            <td>{{ agreement.Agreement }}</td>
                            <td class="text-center">{{ agreement.Gateway.Name }}</td>
                            <td class="text-center">{{ agreement.Order }}</td>
                            <td>
                              <div class="text-right">
                                <b-button size="sm" variant="outline-secondary" @click="OpenMAgreement(idxAgreement)">
                                  <template v-if="isSeeing">
                                    <i class="fas fa-eye mr-2"></i> Visualizar
                                  </template>
                                  <template v-else>
                                    <i class="fas fa-highlighter mr-2"></i> Editar
                                  </template>
                                </b-button>
                                <b-button v-if="!isSeeing" size="sm" variant="outline-secondary"
                                  @click="RemoveAgreement(idxAgreement)">
                                  <i class="fas fa-trash-alt" />
                                </b-button>
                              </div>
                            </td>
                          </tr>
                        </template>
                        <tr v-if="activeOPM.OperatorPaymentMethodAgreements.length == 0">
                          <td colspan="3" class="text-center">Nenhum convênio.</td>
                        </tr>
                      </tbody>
                    </table>

                    <b-row v-if="!isSeeing">
                      <b-col>
                        <b-button class="float-right mt-4 mr-3" variant="success" size="sm"
                          @click="OpenMAgreement(null)">
                          <i class="fas fa-plus mr-2"></i> Novo convênio
                        </b-button>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
              <br>
              <div style="text-align: end;">
                <b-button-group>
                  <b-button size="sm" class="btn btn-secondary" @click="PreviousStep($event)"
                    :disabled="mCurrentStep === 0 || loadingCreateUpdate">
                    <i class="fas fa-arrow-left"></i>
                  </b-button>

                  <b-button size="sm" class="btn btn-secondary" @click="NextStep($event)"
                    v-if="!IsLastEnabledStep(this.mCurrentStep)">
                    <i class="fas fa-arrow-right"></i>
                  </b-button>

                  <b-button type="button" class="btn btn-success" @click="CreateOrUpdate()"
                    :disabled="loadingCreateUpdate" v-if="IsLastEnabledStep(this.mCurrentStep) && !isSeeing">
                    <template v-if="!loadingCreateUpdate">{{
                      idOperator != null ? " Salvar alterações" : " Cadastrar operador"
                      }}</template>
                    <template v-else>
                      <loader :small="true" :isLoading="loadingCreateUpdate"></loader>
                    </template>
                  </b-button>
                </b-button-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



    <!-- Operator Modal -->
    <b-modal id="mFormOperator" :title="modalTitle" size="lg" centered :no-close-on-backdrop="true"
      :no-close-on-esc="false">

      <template slot="modal-viewter">
        <b-button-group>
          <b-button size="sm" class="btn btn-secondary" @click="PreviousStep($event)"
            :disabled="mCurrentStep === 0 || loadingCreateUpdate">
            <i class="fas fa-arrow-left"></i>
          </b-button>

          <b-button size="sm" class="btn btn-secondary" @click="NextStep($event)"
            v-if="!IsLastEnabledStep(this.mCurrentStep)">
            <i class="fas fa-arrow-right"></i>
          </b-button>

          <b-button type="button" class="btn btn-success" @click="CreateOrUpdate()" :disabled="loadingCreateUpdate"
            v-if="IsLastEnabledStep(this.mCurrentStep) && !isSeeing">
            <template v-if="!loadingCreateUpdate">{{
              idOperator != null ? " Salvar alterações" : " Cadastrar operador"
              }}</template>
            <template v-else>
              <loader :small="true" :isLoading="loadingCreateUpdate"></loader>
            </template>
          </b-button>
        </b-button-group>
      </template>
    </b-modal>

    <b-modal id="mFormAgreement" title="Convênio" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <div>
        <ValidationObserver tag="form" ref="agreementForm">
          <b-form-row>
            <b-col md="4" class="form-group">
              <label>Gateway</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select :class="agreementValidate | showValidateError(invalid)" :disabled="isSeeing" :value="null"
                  v-model="activeOPMAgreement.Gateway.Code">
                  <option :value="null" selected>Selecione o Gateway</option>
                  <option v-for="type in gateways" v-bind:key="type.Code" v-bind:value="type.Code">
                    {{ type.Name }}
                  </option>
                </d-select>
                <div class="invalid-feedback d-block" v-if="agreementValidate">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </b-col>

            <b-col md="4" class="form-group">
              <label>Convênio</label>
              <ValidationProvider rules="required|min:3" v-slot="{ errors, invalid }">
                <b-form-input :class="agreementValidate | showValidateError(invalid)" :disabled="isSeeing" type="text"
                  v-model="activeOPMAgreement.Agreement" />
                <div class="invalid-feedback d-block" v-if="agreementValidate">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </b-col>
            <b-col md="4" class="form-group">
              <label>Ordem</label>
              <ValidationProvider rules="required|min:1" v-slot="{ errors, invalid }">
                <b-form-input :class="agreementValidate | showValidateError(invalid)" :disabled="isSeeing" type="number"
                  v-model="activeOPMAgreement.Order" />
                <div class="invalid-feedback d-block" v-if="agreementValidate">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col md="4" class="form-group">
              <label>Carteira</label>
              <ValidationProvider rules="required|min:2" v-slot="{ errors, invalid }">
                <b-form-input :class="agreementValidate | showValidateError(invalid)" :disabled="isSeeing" type="text"
                  v-model="activeOPMAgreement.Wallet" />
                <div class="invalid-feedback d-block" v-if="agreementValidate">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </b-col>
            <b-col md="4" class="form-group">
              <label>Cedente</label>
              <ValidationProvider rules="required|min:3" v-slot="{ errors, invalid }">
                <b-form-input :class="agreementValidate | showValidateError(invalid)" :disabled="isSeeing" type="text"
                  v-model="activeOPMAgreement.CodeAssignor" />
                <div class="invalid-feedback d-block" v-if="agreementValidate">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </b-col>
            <b-col md="4" class="form-group">
              <label>Estação</label>
              <ValidationProvider rules="required|min:4" v-slot="{ errors, invalid }">
                <b-form-input :class="agreementValidate | showValidateError(invalid)" :disabled="isSeeing" type="text"
                  v-model="activeOPMAgreement.Station" />
                <div class="invalid-feedback d-block" v-if="agreementValidate">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </b-col>
          </b-form-row>
          <b-form-row v-if="selected_payment == 1">
            <b-col md="6" class="form-group">
              <label>Agência</label>
              <ValidationProvider rules="required|numeric" v-slot="{ errors, invalid }">
                <b-form-input :class="agreementValidate | showValidateError(invalid)" :disabled="isSeeing" maxlength="8"
                  type="text" v-model="activeOPMAgreement.BankAgency" />
                <div class="invalid-feedback d-block" v-if="agreementValidate">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </b-col>

            <b-col md="6" class="form-group">
              <label>Digito da agência</label>
              <ValidationProvider rules="required|numeric" v-slot="{ errors, invalid }">
                <b-form-input :class="agreementValidate | showValidateError(invalid)" :disabled="isSeeing" maxlength="1"
                  type="text" v-model="activeOPMAgreement.BankAgencyDigit" />
                <div class="invalid-feedback d-block" v-if="agreementValidate">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </b-col>
          </b-form-row>

          <b-form-row v-if="selected_payment == 1">
            <b-col md="6" class="form-group">
              <label>Conta</label>
              <ValidationProvider rules="required|numeric" v-slot="{ errors, invalid }">
                <b-form-input :class="agreementValidate | showValidateError(invalid)" :disabled="isSeeing"
                  maxlength="10" type="text" v-model="activeOPMAgreement.BankAccount" />
                <div class="invalid-feedback d-block" v-if="agreementValidate">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </b-col>

            <b-col md="6" class="form-group">
              <label>Digito da conta</label>
              <ValidationProvider rules="required|numeric" v-slot="{ errors, invalid }">
                <b-form-input :class="agreementValidate | showValidateError(invalid)" :disabled="isSeeing" maxlength="1"
                  type="text" v-model="activeOPMAgreement.BankAccountDigit" />
                <div class="invalid-feedback d-block" v-if="agreementValidate">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </b-col>
          </b-form-row>

          <b-form-row v-if="IsOnTheList(this.selected_payment, [1, 2, 3, 4])">
            <b-col md="6" class="form-group" v-if="IsOnTheList(this.selected_payment, [2, 3, 4])">
              <label>Código de estabelecimento</label>
              <ValidationProvider rules="required|min:2" v-slot="{ errors, invalid }">
                <b-form-input :class="agreementValidate | showValidateError(invalid)" :disabled="isSeeing" type="text"
                  v-model="activeOPMAgreement.CodeEstablishment" />
                <div class="invalid-feedback d-block" v-if="agreementValidate">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </b-col>

            <b-col md="6" class="form-group">
              <label>Código do Cliente</label>
              <ValidationProvider rules="required|min:2" v-slot="{ errors, invalid }">
                <b-form-input :class="agreementValidate | showValidateError(invalid)" :disabled="isSeeing" type="text"
                  v-model="activeOPMAgreement.MerchantId" />
                <div class="invalid-feedback d-block" v-if="agreementValidate">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </b-col>
            <b-col md="6" class="form-group">
              <label>Chave do Cliente</label>
              <ValidationProvider rules="required|min:2" v-slot="{ errors, invalid }">
                <b-form-input :class="agreementValidate | showValidateError(invalid)" :disabled="isSeeing" type="text"
                  v-model="activeOPMAgreement.MerchantKey" />
                <div class="invalid-feedback d-block" v-if="agreementValidate">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </b-col>
          </b-form-row>

          <!-- <b-form-row v-if="IsOnTheList(this.selected_payment, [1, 2, 3, 4])">
           
          </b-form-row> -->
        </ValidationObserver>
      </div>

      <template v-slot:modal-footer="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="secondary" @click="cancel()">
          <template v-if="isSeeing">Fechar</template>
          <template v-else>Cancelar</template>
        </b-button>
        <b-button
          size="sm"
          v-if="!isSeeing"
          variant="success"
          @click="SaveAgreement()"
          >Salvar</b-button
        >
      </template>
    </b-modal>


  </div>
</template>

<script>
  import { hasValue } from "../../utils/functions.js";
  import dateField from "@/components/common/date-field";
  export default {
    name: "OperadoresDetalhes",
    props: ["modo"],
    data() {
      return {
        activeOPM: {
          OperatorPaymentMethodAgreements: [],
          PaymentMethod: {
            Code: null,
          },
        },
        activeOPMAgreement: {
          Agreement: null,
          BankAccount: null,
          BankAccountDigit: null,
          BankAgency: null,
          BankAgencyDigit: null,
          CodeEstablishment: null,
          Gateway: {
            Code: null,
          },
          MerchantId: null,
          MerchantKey: null,
        },
        activeOPMAgreementIndexes: {
          OPMAgreement: null,
          PaymentCode: null,
        },
        agreementsTableKey: 0,
        agreementValidate: false,
        cities: [],
        countFilter: 0,
        countries: [],
        filter: {
          Identity: null,
          IsRemoved: null,
          Name: null,
        },
        gateways: [],
        idOperator: null,
        infoOperator: {
          Address: {
            City: {
              Name: null,
            },
            Complement: null,
            Country: {
              Name: null,
            },
            District: null,
            Number: null,
            Street: null,
            ZipCode: null,
            State: {
              Initials: null,
            },
          },
          CommercialName: null,
          Email: null,
          Identity: null,
          Name: null,
          OperatorPaymentMethod: [],
          ResponsibleIdentity: null,
          ResponsiblePhone: null,
          NomeOperador: null,
          Observacao: null,
          IsRemoved: false,
        },
        isSearchZipCode: false,
        isSeeing: false,
        keyOPMtable: 0,
        loadingCreateUpdate: false,
        loadingList: false,
        loadingModal: false,
        loadingReport: false,
        loadingUpdateDesativar: false,
        validateDesativarOperadorForm: false,
        desativarOperador: {
          Id: 0,
          Name: null,
          Identity: null,
          Observacao: null,
          IsRemoved: false,
        },
        mCurrentStep: 0,
        modalTitle: "Detalhes do operador",
        operators: [],
        pagination: {
          PageNumber: 1,
          RowsPerPage: 10,
          TotalItems: 0,
        },
        noteExtracts: [],
        paymentMethods: [],
        selected_payment: null,
        states: [],
        steps: [
          {
            isEnabled: true,
            isValidated: false,
            title: "Empresa",
            validation: "companyInfo",
          },
          {
            isEnabled: true,
            isValidated: undefined,
            title: "Métodos de pagamento",
            validation: "operatorPaymentInfo",
          },
        ],
      };
    },
    components: {
      dateField,
    },
    computed: {
      Country() {
        return this.infoOperator.Address.Country.Name;
      },
      State() {
        return this.infoOperator.Address.State.Initials;
      },
    },
    watch: {
      "pagination.PageNumber": function () {
        this.ListOperator();
      },
      "pagination.RowsPerPage": function () {
        this.ListOperator();
      },
      selected_payment(codeSelected) {
        if (codeSelected === undefined) {
          this.selected_payment = null;
          return;
        }
        const opm = this.infoOperator.OperatorPaymentMethod;
        const paymentMethod = opm.find((elm) => {
          return elm.PaymentMethod.Code === codeSelected;
        });
        if (paymentMethod) this.activeOPM = paymentMethod;
        else if (codeSelected != null) {
          const newPymtMethod = {
            OperatorPaymentMethodAgreements: [],
            PaymentMethod: {
              Code: codeSelected,
            },
          };
          const idxNewPymt =
            this.infoOperator.OperatorPaymentMethod.push(newPymtMethod) - 1;
          this.activeOPM = this.infoOperator.OperatorPaymentMethod[idxNewPymt];
        }
      },
      State(selected, old) {
        // Update City list when the State (of Country) is changed.
        if (selected != null) {
          this.$store
            .dispatch("ListCity", { stateInitials: selected })
            .then((response) => {
              this.cities = response;
            });
          if (selected != old && old != undefined && !this.isSearchZipCode) {
            this.infoOperator.Address.City.Name = null;
          }
        } else {
          this.cities = [];
          this.infoOperator.Address.City.Name = null;
        }
        this.isSearchZipCode = false;
      },
      Country(selected, old) {
        // Update State list when the Country is changed.
        if (selected != null) {
          this.ListState(selected);
          if (selected != old && old != undefined && !this.isSearchZipCode) {
            this.infoOperator.Address.State.Initials = null;
          }
        } else {
          this.states = [];
          this.infoOperator.Address.State.Initials = null;
        }
        this.isSearchZipCode = false;
      },
    },

    mounted() {
      console.log(this.modo);
      console.log(this.$route.params.idOperator);
      console.log(this.$route.params.modo);
      console.log(this.idOperator);
      if (this.$route.params.modo == "Editar" && this.$route.params.idOperator != undefined) {
        // Edit
        this.idOperator = this.$route.params.idOperator;
        this.isSeeing = false;
        document.getElementById('modalTitle').innerText = "Editar operador";
        this.GetOperator(this.$route.params.idOperator);
      } else if (this.$route.params.modo == "Novo" && this.$route.params.idOperator == undefined) {
        // Add new
        this.idOperator = null;
        this.isSeeing = false;
        document.getElementById('modalTitle').innerText = "Novo operador";
      } else  if (this.$route.params.modo == "Visualizar" && this.$route.params.idOperator != undefined){
        // View
        this.idOperator = this.$route.params.idOperator;
        this.isSeeing = true;
        document.getElementById('modalTitle').innerText = "Detalhes do operador";
        this.GetOperator(this.idOperator);
      }

      if (this.$route.params.idOperador !== null && this.$route.params.idOperador !== undefined) {
        this.idOperador = this.$route.params.idOperador;
      }
      this.ListOperator();
      this.ListCountry();
      this.ListPaymentMethods();
      this.ListGateways();
    },
    methods: {
      AddOperator: function () {
        this.loadingCreateUpdate = true;
        this.$store
          .dispatch("AddOperator", this.infoOperator)
          .then(() => {
            this.ListOperator();
            this.$makeToast(
              "Operador cadastrado com sucesso",
              "success",
              "Cadastrado"
            );
            this.$bvModal.hide("mFormOperator");
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao cadastrar operador",
              error
            );
          })
          .finally(() => {
            this.loadingCreateUpdate = false;
            this.Operadores();
          });
      },
      CreateOrUpdate: function () {
        if (this.idOperator == null) {
          this.AddOperator();
        } else {
          this.$makeMsgBox(
            "Você confirma a alteração dos dados?",
            "Confirmar alterações",
            this.UpdateOperator
          );
        }
      },
      Filter() {
        this.$bvModal.hide("mFilter");
        this.ListOperator();
      },
      GetNextEnabledStep(startingStep) {
        // And with validation step!
        if (!startingStep) startingStep = this.mCurrentStep + 1;

        for (let i = startingStep; i < this.steps.length; i++) {
          const step = this.steps[i];
          if (step.isEnabled && step.isValidated != undefined) return i;
        }
        return null;
      },
      GetOperator(id) {
        this.loadingModal = true;

        this.$store
          .dispatch("GetOperator", { id: id })
          .then((resp) => {
            this.infoOperator = resp;
          })
          .catch((error) => {
            this.$makeToast(
              "Não foi possível buscar as informações do operador",
              "danger",
              "Erro ao carregar operador",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      },
      GetPaymentNameByCode(code) {
        const pymt = this.paymentMethods.find((elm) => {
          return elm.Code == code;
        });
        return pymt ? pymt.Name : "";
      },
      GoToStep(stepToGo, ev) {
        if (ev.preventDefault != undefined) ev.preventDefault();
        // Apply your logic here
        const curStep = this.steps[this.mCurrentStep];
        const canGoBack = true;
        const canJumpSteps = false;
        const curValidation = this.$refs[curStep.validation];

        if (curStep.isValidated === undefined) {
          if (!canJumpSteps && this.mCurrentStep + 2 >= stepToGo) {
            const nextStep = this.GetNextEnabledStep();
            if (nextStep) {
              if (nextStep < stepToGo) {
                this.mCurrentStep = nextStep;
                this.GoToStep(stepToGo, ev);
                return;
              }
            }
          }
          this.mCurrentStep = stepToGo;
        } else {
          curValidation.validate().then((isValid) => {
            if (
              isValid ||
              this.isSeeing ||
              (!isValid && canGoBack && stepToGo < this.mCurrentStep)
            ) {
              if (!canJumpSteps && this.mCurrentStep + 2 >= stepToGo) {
                const nextStep = this.GetNextEnabledStep();
                if (nextStep) {
                  if (nextStep < stepToGo) {
                    this.mCurrentStep = nextStep;
                    curStep.isValidated = false;
                    this.GoToStep(stepToGo, ev);
                    return;
                  }
                }
              }
              this.mCurrentStep = stepToGo;
              curStep.isValidated = false;
            } else {
              curStep.isValidated = true;
            }
          });
        }
      },
      IsLastEnabledStep(idxStep) {
        if (this.steps[idxStep].isEnabled === false) return false;
        for (let i = idxStep + 1; i < this.steps.length; i++) {
          const step = this.steps[i];
          if (step.isEnabled) return false;
        }
        return true;
      },
      IsOnTheList(elm, list) {
        if ((elm == null) | (list == null)) return false;

        for (let i = 0; i < list.length; i++) {
          if (list[i] == elm) return true;
        }
        return false;
      },
      IsPaymentAlreadyAdded(code) {
        let wasAdded = false;
        this.infoOperator.OperatorPaymentMethod.forEach((elm) => {
          if (elm.PaymentMethod.Code == code) wasAdded = true;
        });
        return wasAdded;
      },
      ListCountry() {
        this.$store
          .dispatch("ListCountry")
          .then((response) => {
            this.countries = response;
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro carregar a lista de países",
              error
            );
          });
      },
      ListGateways() {
        this.$store
          .dispatch("ListGateway")
          .then((response) => {
            this.gateways = response;
          })
          .catch((error) => {
            this.$makeToast(
              "Tente novamente...",
              "danger",
              "Erro ao obter a lista de gateways",
              error
            );
          });
      },
      ListOperator() {
        this.countFilter = 0;
        if (hasValue(this.filter.Identity)) this.countFilter++;
        if (hasValue(this.filter.IsRemoved)) this.countFilter++;
        if (hasValue(this.filter.Name)) this.countFilter++;
        this.loadingList = true;
        let params = {
          "Object.Identity": this.filter.Identity,
          "Object.IsRemoved": this.filter.IsRemoved,
          "Object.Name": this.filter.Name,
          ...this.pagination,
        };
        delete params.TotalItems;
        this.$store
          .dispatch("ListOperator", { params: params })
          .then((response) => {
            this.operators = response.Objects;
            this.pagination.TotalItems = response.TotalItems;
          })
          .catch((error) => {
            this.$makeToast(
              "Não foi possível listar os operadores",
              "danger",
              "Erro ao listar operadores",
              error
            );
          })
          .finally(() => {
            this.loadingList = false;
          });
      },
      ListPaymentMethods() {
        this.$store
          .dispatch("ListPaymentMethodIsEnabled")
          .then((response) => {
            this.paymentMethods = response.Objects;
          })
          .catch((error) => {
            this.$makeToast(
              "Tente novamente...",
              "danger",
              "Erro ao obter a lista dos metodos de pagamento",
              error
            );
          });
      },
      ListState(nameCountry) {
        if (nameCountry != null) {
          let CountryItem = this.countries.find((elem) => {
            return elem.Name.toUpperCase() == nameCountry;
          });

          if (CountryItem != null && CountryItem.Id != null) {
            this.$store
              .dispatch("ListState", { idCountry: CountryItem.Id })
              .then((response) => {
                this.states = response;
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao obter lista de estados",
                  error
                );
              });
          }
        }
      },
      NextStep(ev) {
        const idxCurStep = this.mCurrentStep;
        if (idxCurStep + 1 === this.steps.length) return;
        for (let i = idxCurStep + 1; i < this.steps.length; i++) {
          const curStep = this.steps[i];
          if (curStep.isEnabled) {
            this.GoToStep(i, ev);
            return;
          }
        }
      },
      OpenMAgreement(idxAgreement) {
        this.activeOPMAgreementIndexes.PaymentCode = this.selected_payment;
        if (idxAgreement != null) {
          this.activeOPMAgreement = JSON.parse(
            JSON.stringify(
              this.activeOPM.OperatorPaymentMethodAgreements[idxAgreement]
            )
          );
          this.activeOPMAgreementIndexes.OPMAgreement = idxAgreement;
        } else {
          this.activeOPMAgreement = {
            Agreement: null,
            BankAccount: null,
            BankAccountDigit: null,
            BankAgency: null,
            BankAgencyDigit: null,
            CodeEstablishment: null,
            Gateway: {
              Code: null,
            },
            MerchantId: null,
            MerchantKey: null,
          };
          this.activeOPMAgreementIndexes.OPMAgreement = null;
        }
        this.$bvModal.show("mFormAgreement");
      },
      OpenModalFilter() {
        this.$bvModal.show("mFilter");
      },
      OpenOperator(e, i, view) {
        e.preventDefault();
        this.ResetInfoOperator();
        this.ResetModal();
        this.selected_payment = null;

        if (view == undefined && i != undefined) {
          // Edit
          this.idOperator = this.operators[i].Id;
          this.isSeeing = false;
          this.modalTitle = "Editar operador";
          this.GetOperator(this.idOperator);
        } else if (view == undefined && i == undefined) {
          // Add new
          this.idOperator = null;
          this.isSeeing = false;
          this.modalTitle = "Novo operador";
        } else {
          // View
          this.idOperator = this.operators[i].Id;
          this.isSeeing = true;
          document.getElementById('title').innerText = 'Crie sua nova senha!';
          this.GetOperator(this.idOperator);
        }
        this.$bvModal.show("mFormOperator");
      },
      PreviousStep(ev) {
        const idxCurStep = this.mCurrentStep;
        if (idxCurStep <= 0) return;
        for (let i = idxCurStep - 1; i >= 0; i--) {
          const curStep = this.steps[i];
          if (curStep.isEnabled) {
            this.GoToStep(i, ev);
            return;
          }
        }
      },

      ProcessOperatorUpdateActivation(i, disable) {
        const operator = this.operators[i];
        const identity = this.$options.filters.identity(operator.Identity);

        this.$makeMsgBox(
          `Você tem certeza que deseja ${disable ? "desativar" : "ativar"} ${operator.Name
          } (${identity}) ?`,
          "Confirmar ação",
          this.UpdateOperatorRemoved,
          operator,
          disable
        );
      },
      RemoveAgreement(idxAgreement) {
        this.activeOPM.OperatorPaymentMethodAgreements.splice(idxAgreement, 1);
        this.UpdateOPM();
      },
      RemovePayment(idxPayment) {
        this.infoOperator.OperatorPaymentMethod.splice(idxPayment, 1);
        this.keyOPMtable += 1;
      },
      ResetFilter() {
        this.filter = {
          Identity: null,
          IsRemoved: null,
          Name: null,
        };
        this.ListOperator();
      },
      ResetInfoOperator() {
        this.idOperator = null;
        this.infoOperator = {
          Address: {
            City: {
              Name: null,
            },
            Complement: null,
            Country: {
              Name: null,
            },
            District: null,
            Number: null,
            Street: null,
            ZipCode: null,
            State: {
              Initials: null,
            },
          },
          CommercialName: null,
          Email: null,
          Identity: null,
          Name: null,
          OperatorPaymentMethod: [],
          ResponsibleIdentity: null,
          ResponsiblePhone: null,
          NomeOperador: null,
          IsRemoved: false,
        };
      },
      ResetModal() {
        this.mCurrentStep = 0;
        this.steps.forEach((step) => {
          if (step.isValidated != undefined) {
            step.isValidated = false;
          }
        });
      },
      SaveAgreement() {
        this.agreementValidate = true;
        this.$refs["agreementForm"].validate().then((isValid) => {
          if (isValid) {
            this.agreementValidate = false;
            const idxAgreement = this.activeOPMAgreementIndexes.OPMAgreement;
            //Logica para obtencao do nome do gateway
            const gateway = this.gateways.find(x => x.Code == this.activeOPMAgreement.Gateway.Code);
            this.activeOPMAgreement.Gateway = gateway;
            if (idxAgreement != null) {
              this.activeOPM.OperatorPaymentMethodAgreements[
                idxAgreement
              ] = JSON.parse(JSON.stringify(this.activeOPMAgreement));
            } else {
              this.activeOPM.OperatorPaymentMethodAgreements.push(
                JSON.parse(JSON.stringify(this.activeOPMAgreement))
              );
            }

            this.$bvModal.hide("mFormAgreement");
            this.UpdateOPM();
          }
        });
      },
      SearchByZipCode() {
        if (this.isSeeing == false) {
          let zipCodeNumber = this.infoOperator.Address.ZipCode.replace(
            /\D+/gm,
            ""
          );

          if (zipCodeNumber.length != 8) {
            this.$makeToast(
              "O CEP digitado não é válido. " + zipCodeNumber,
              "danger",
              "CEP Inválido"
            );
            return;
          }

          this.$store
            .dispatch("ListCep", { zipCode: zipCodeNumber })
            .then((response) => {
              if (response.erro) {
                this.$makeToast(
                  "Verifique o número digitado e tente novamente.",
                  "warning",
                  "CEP não encontrado"
                );
                return;
              }
              this.isSearchZipCode = true;

              this.infoOperator.Address.ZipCode = response.cep;
              this.infoOperator.Address.Street = response.logradouro;
              this.infoOperator.Address.District = response.bairro;

              this.infoOperator.Address.Country.Name = "BRASIL";
              this.infoOperator.Address.State.Initials = response.uf;
              this.infoOperator.Address.City.Name = response.localidade;
            })
            .catch((error) => {
              this.$makeToast(
                "Não foi possível buscar o endereço.",
                "danger",
                "Busca de endereço"
              );
            });
        }
      },
      UpdateOperator: function () {
        this.loadingCreateUpdate = true;
        this.$store
          .dispatch("UpdateOperator", this.infoOperator)
          .then(() => {
            this.$makeToast(
              "O operador foi atualizado com sucesso",
              "success",
              "Atualizado"
            );
            this.ListOperator();
            this.$bvModal.hide("mFormOperator");
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao atualizar operador " + this.infoOperator.Name + ".",
              error
            );
          })
          .finally(() => {
            this.loadingCreateUpdate = false;
            this.Operadores();
          });
      },

      ResetOPeradorDesativar: function () {
        this.desativarOperador = {
          Id: 0,
          Name: null,
          Identity: null,
          Observacao: null,
          IsRemoved: false,
        }
      },
      AbrirModalDesativarEAtivaOperador(i) {
        this.validateDesativarOperadorForm = false;
        this.ResetOPeradorDesativar();
        this.desativarOperador = this.operators[i];
        this.$bvModal.show("mFormAtivarEDesativarOperador");
      },

      UpdateOperatorRemoved: function (disable) {
        const label = disable ? "desativado" : "ativado";
        const operatorRemoved = {
          Id: this.desativarOperador.Id,
          IsRemoved: disable,
          Observacao: this.desativarOperador.Observacao
        };

        this.validateDesativarOperadorForm = true;
        this.$refs.DesativarOperadorForm.validate().then((isValid) => {

          if (disable == false || isValid == true) {
            this.loadingUpdateDesativar = true;
            this.$store
              .dispatch("UpdateOperatorRemoved", operatorRemoved)
              .then(() => {
                this.ListOperator();
                this.$makeToast(
                  `${operatorRemoved.Name} foi ${label}`,
                  "success",
                  `Operador ${label}`);
                this.$bvModal.hide("mFormAtivarEDesativarOperador");
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  `Falha ao ${disable ? "desativar" : "ativar"} ${operatorRemoved.Name}.`,
                  error
                );
              }).finally(() => (this.loadingUpdateDesativar = false));
          }
        });
      },

      UpdateOPM() {
        const opm = JSON.parse(JSON.stringify(this.activeOPM));
        const idxPymt = this.infoOperator.OperatorPaymentMethod.findIndex(
          (elm) => {
            elm.PaymentMethod.Code === this.selected_payment;
          }
        );
        this.infoOperator.OperatorPaymentMethod[idxPymt] = opm;
        this.agreementsTableKey += 1;
      },

      Operadores: function () {
      this.$router.push({
        name: "operators",
      });
    },
    },
  };
</script>

<style scoped>
  .td-with-subs {
    display: block;
  }

  .td-with-subs>span {
    font-size: 10pt;
    opacity: 0.75;
  }

  .nav-steps .breadcrumb-item:before {
    content: none;
  }

  .nav-steps .breadcrumb-item .active {
    text-decoration: underline;
    font-weight: 600;
  }
</style>


// WEBPACK FOOTER //
// src/components/pages/OperadoresDetalhes.vue